<!-- youtube-mobile-02 preview — YouTube watch ad -->
<app-mobile-frame>
  <!-- START: Watch screen -->
  <div class="yt-m-feed yt-w-screen">
    <!-- START: Player — pinned, the body scrolls underneath it -->
    <div class="yt-w-player">
      <img
        class="yt-w-player-image"
        src="/assets/images/youtube-placeholder-video.png"
        alt=""
      />
    </div>
    <!-- END: Player -->

    <!-- START: Scrollable body -->
    <div class="yt-w-scroll">
      <!-- START: Watched video metadata placeholder -->
      <div class="yt-m-card yt-w-meta">
        <span class="yt-m-bar yt-w-bar-title placeholder"></span>
        <span class="yt-m-bar yt-w-bar-subtitle placeholder"></span>

        <div class="yt-w-channel d-flex flex-row align-items-center gap-2">
          <span class="yt-m-circle placeholder"></span>
          <span class="yt-m-bar yt-w-bar-channel placeholder"></span>
          <span class="yt-w-pill yt-w-pill-subscribe placeholder ms-auto"></span>
        </div>

        <div class="yt-w-chips d-flex flex-row gap-2">
          <span class="yt-w-pill yt-w-chip-wide placeholder"></span>
          <span class="yt-w-pill yt-w-chip-narrow placeholder"></span>
          <span class="yt-w-pill yt-w-chip-narrow placeholder"></span>
          <span class="yt-w-pill yt-w-chip-medium placeholder"></span>
        </div>

        <span class="yt-w-panel placeholder"></span>
      </div>
      <!-- END: Watched video metadata placeholder -->

      <!-- START: Real ad -->
      <div class="yt-m-card">
        <div class="yt-m-creative">
          <img *ngIf="creativeImage" class="yt-m-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="yt-m-creative-image creative-missing">{{ missingDimensionLabel }}</div>
          <i class="bi bi-info-circle-fill yt-m-info-badge"></i>
        </div>

        <div
          class="yt-m-cta d-flex flex-row align-items-center justify-content-between"
        >
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="yt-m-cta-text"
            >{{ data.ctaText || "Your call to action" }}
          </a>
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="yt-m-cta-text"
            ><i class="bi bi-box-arrow-up-right"></i
          ></a>
        </div>

        <div class="yt-m-info d-flex flex-row gap-2">
          <img
            class="yt-m-avatar"
            src="assets/images/valamar_logo_80x80.jpg"
            alt=""
          />
          <div class="yt-m-info-text">
            <h4 class="yt-m-title">
              {{ data.headlines[0] || "Your headline appears here" }}
            </h4>
            <div class="yt-m-desc">
              {{ data.descriptions[0] || "Your description appears here" }}
            </div>
            <div class="yt-m-meta"><strong>Sponsored</strong> &middot; Valamar</div>
          </div>
          <i class="bi bi-three-dots-vertical yt-m-more"></i>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
    <!-- END: Scrollable body -->
  </div>
  <!-- END: Watch screen -->
</app-mobile-frame>
